import React from 'react';
import { Button } from 'carbon-components-react';
import { Add16, Delete16 } from '@carbon/icons-react';
import './ObjectTemplate.scss';

const ObjectTemplate = props => {
  return (
    <div
      className={props.className + ' array-subform w-100'}
      style={{ border: '1px solid red' }}
    >
      <div className='array-title'>
        {props.items && props.items.length ? props.schema.title : ''}
      </div>
      <div className='subform-items'>
        {props.items &&
          props.items.map(element => {
            return (
              <div
                key={element.key}
                className={
                  element.className + ' w-100 justify-content-between row m-0'
                }
                style={{ border: 'none' }}
              >
                {element.children}

                <Button
                  className='bx--btn bx--btn--ghost bx--btn--sm remove-button'
                  onClick={element.onDropIndexClick(element.index)}
                >
                  <Delete16 aria-label='Delete' />
                </Button>
              </div>
            );
          })}
      </div>

      {props.canAdd && (
        <div className='row'>
          <p className='col-xs-3 col-xs-offset-9 array-item-add text-right'>
            <Button
              className='bx--btn bx--btn--ghost bx--btn--sm add-item-button'
              onClick={props.onAddClick}
              renderIcon={Add16}
            >
              Añadir saca
            </Button>
          </p>
        </div>
      )}
    </div>
  );
};

export default ObjectTemplate;
